export const getUnformattedZipcode = (zipcode?: string) => {
  return zipcode?.replace(/\.|\-/g, '') || '';
};

export const getFormattedZipcode = (zipcode?: string) => {
  return zipcode?.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2') || '';
};
